import { FaPlusCircle } from 'react-icons/fa';

function PainDiaryEmptyState({
    newEntry,
    canEdit
}) {
    return (
        <div style={{ flex: 1, border: 'none', boxShadow: 'none' }} class="pain-diary">
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} className="loading">
                <div>No Entries.</div>
                {canEdit && (
                    <button
                        className="add-new-button"
                        onClick={newEntry}
                        style={{
                            marginTop: '0px',
                            background: 'none',
                            border: 'none',
                            padding: 0,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            cursor: 'pointer',
                            fontSize: '1rem'
                        }}
                    >
                        <FaPlusCircle size={16} style={{ color: '#3498db' }} />
                        <span style={{ color: '#3498db' }}>
                            Create Your First Pain Diary Entry
                        </span>
                    </button>
                )}
            </div>
        </div>
    )
}

export default PainDiaryEmptyState;